import { render, staticRenderFns } from "./ItemBadge.vue?vue&type=template&id=54d4138d&scoped=true&"
import script from "./ItemBadge.vue?vue&type=script&lang=js&"
export * from "./ItemBadge.vue?vue&type=script&lang=js&"
import style0 from "./ItemBadge.vue?vue&type=style&index=0&id=54d4138d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4138d",
  null
  
)

export default component.exports